import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'companyCode',
                label: '公司代码',
                type: 'input'
            },
            {
                prop: 'step',
                label: '任务描述',
                type: 'select',
                selectval: comMapping.$step
            },
            {
                prop: 'faqTime',
                label: '执行起止',
                type: "date",
                valueformat:'yyyy-MM-dd'
            },
            {
                prop: 'type',
                label: '任务明细',
                type: 'select',
                selectval: comMapping.$dsrwType
            },
            {
                prop: 'status',
                label: '执行状态',
                type: 'select',
                selectval: comMapping.$zxzt
            },
            {
                prop: 'ssq',
                label: '所属期',
                type: "datemonth",
                valueformat:'yyyyMM'
            },
        ],
        searchdata: {
            companyCode: '',
            step: '',
            faqTime: '',
            type: '',
            status: '',
            ssq: ''
        },
        headData: [
            {
                title: '所属期',
                prop: 'ssq',
                width: 80,
                custom: true

            },
            {
                title: '任务描述',
                prop: 'step',
                width: 130,
                custom: true

            },
            {
                title: '公司代码',
                prop: 'companyCode',
                width: 80,
                custom: true

            },
            {
                title: '任务明细',
                prop: 'type',
                width: 130,
                custom: true

            },
            {
                title: '执行状态',
                prop: 'status',
                width: 80,
                custom: true

            },
            {
                title: '申报通道',
                prop: 'tunnelType',
                width: 70,
                custom: true

            },
            {
                title: '失败原因',
                prop: 'cank2',
                custom: true,
                width: 250
            },
            {
                title: '执行开始时间',
                prop: 'faqTime',
                custom: true,
                width: 160
            },
            {
                title: '执行结束时间',
                prop: 'faqTime',
                custom: true,
                width: 160
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
